<ng-container *ngIf="mode == 'animation'">
  <button (click)="toggle()"
          class="btn bg-grad-blue d-flex align-items-center justify-content-between gap-2 border-0"
          type="button">
    <lf-icon *ngIf="icon1" class="transition05 rotated_icon"
      height="13px" name="{{icon1}}" width="13px"></lf-icon>
    <div *ngIf="text1" class="displayedOnHover text-white text_2 text-nowrap">
      {{(text2 && isToggle ? text2 : text1) | translate}}
    </div>
    <lf-icon *ngIf="icon2 && !hideIcon2" fillColor="white" height="16px" name="{{icon2}}" width="16px"></lf-icon>
    <lf-icon *ngIf="icon3 && hideIcon2" fillColor="white" height="16px" name="{{icon3}}" width="16px"></lf-icon>
  </button>
</ng-container>

<!--------------------------------------------------------------------------------------------------------------->

<ng-container *ngIf="mode == 'toggle'">
  <div class="contain br-8 overflow-hidden">
    <div [ngClass]="toggledItem" class="br-8 d-flex position-relative bg-white">
      <button (click)="toggleLeftRight('left')" class="btn border-0 " type="button">
        <lf-icon *ngIf="icon1" height="16px" name="{{toggledItem == 'right' ? icon1 : icon4}}"></lf-icon>
      </button>
      <button (click)="toggleLeftRight('right')" class="btn border-0" type="button">
        <lf-icon *ngIf="icon2" height="16px" name="{{toggledItem == 'left' ? icon2 : icon3}}"></lf-icon>
      </button>
    </div>
  </div>
</ng-container>
